import { useMutation } from '@tanstack/react-query';
import {
  aiAgentClient,
  DraftDescriptionRequest,
  DraftDescriptionResponse,
} from 'src/lib/services/api/ai-agent-api';

/**
 * Wraps /api/ai-agent/draft-description as a single mutation. Each call is
 * independent — no optimistic updates or cache invalidation (drafts only
 * live in panel state until the user clicks Insert). The Laravel proxy
 * throttles at 30/min per user; 429 surfaces through the mutation's `error`.
 */
export const useDraftDescription = () => {
  return useMutation<DraftDescriptionResponse, unknown, DraftDescriptionRequest>({
    mutationFn: (payload) => aiAgentClient.draftDescription(payload),
  });
};
